module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dot-nav",
    class: {
      'is-inverted': _vm.inverted
    }
  }, [_c('div', {
    staticClass: "list"
  }, [_c('div', {
    ref: "line",
    staticClass: "list-line"
  }), _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      ref: "items",
      refInFor: true,
      staticClass: "list-item",
      class: {
        'is-active': index === _vm.current && !_vm.animating
      }
    }, [_c('span', {
      staticClass: "list-item__dot",
      class: {
        'has-label': item.label
      }
    }), _c('transition', {
      on: {
        "enter": _vm.labelEnter,
        "leave": _vm.labelLeave
      }
    }, [(item.label && index === _vm.current && !_vm.animating) ? _c('div', {
      staticClass: "list-item__label"
    }, [_c('span', [_vm._v(_vm._s(item.label))])]) : _vm._e()])], 1)
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57223f09","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dots.vue
// module id = 486
// module chunks = 0